import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {Login} from './pages/Login';
import {NavAppBar} from './components/NavAppBar';
import {Footer} from './components/Footer';
import {Home} from './pages/Home';
import {Update} from './pages/Update';
import {RequireAuth} from './components/RequireAuth';

import {ThemeProvider} from '@mui/material/styles';
import {CssBaseline} from '@mui/material';
import { tempcoTheme } from './state/theme/tempcoTheme';

function App() {
    return (
        <ThemeProvider theme={tempcoTheme}>
            <CssBaseline/>
            <Router>
                <div style={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
                    <NavAppBar/>
                    <main style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                        <Routes>
                            <Route path="/" element={<Login/>}/>
                            <Route path="/Home/:quotenum" element={<RequireAuth><Home/></RequireAuth>}/>
                            <Route path="/Home" element={<RequireAuth><Home/></RequireAuth>}/>
                            <Route path="/Update" element={<RequireAuth><Update/></RequireAuth>}/>
                        </Routes>
                    </main>
                    <Footer/>
                </div>
            </Router>
        </ThemeProvider>
    );
}

export default App;